import React from "react";
import { SlideFrame } from "./Slide.styles";
import type { SlideProps } from "./Slide.types";

/**
 * Full-size PPT-style slide frame (Figma 3730:514832).
 * Stateless — fills its parent's width at a fixed 16:9 aspect ratio.
 * Pass slide content as children.
 */
export const Slide: React.FC<SlideProps> = ({ children, className }) => (
  <SlideFrame className={className} data-surface-paint>{children}</SlideFrame>
);

export default Slide;
